module.exports = __webpack_public_path__ + "img/print-invoice.5d4360d3.svg";